import styled, { css } from 'styled-components';
import { Layout } from 'antd';
import { upperBarBaseStyle } from 'consts/styles/upperBarBaseStyle';

export const ContainerRow = styled(Layout.Header)`
    ${({ theme }) => css`
        ${upperBarBaseStyle};
        justify-content: flex-start;
        gap: 12px;

        height: ${theme.sizes.auth.authUpperNavBarHeightMobile}px;

        @media (${theme.sizes.mediaQueries.mobileMax}) {
            padding-right: 0;
        }

        @media (${theme.sizes.mediaQueries.desktopMin}) {
            height: ${theme.sizes.auth.authUpperNavBarHeight}px;
        }
    `}
`;

export const VerticalLine = styled.div`
    ${({ theme }) => css`
        border-left: 1px solid ${theme.colors.primary.primary3};
        height: 50%;
    `}
`;
